import { useEffect } from 'react';

export const useGlobalEvent = (event: string, callback: (e) => void): void => {
    useEffect(() => {
        window.addEventListener(event, callback);
        return () => window.removeEventListener(event, callback);
    }, []);
};
